// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagination{margin-top:60px}.pagination__list{margin:0;padding:0;list-style:none;display:flex;align-items:center;justify-content:center}.pagination__link{transition:all .1s;display:inline-block;padding:4px 12px;border-radius:4px;color:#d36133;font-size:16px;text-decoration:none;margin:0 2px}.pagination__link:hover{background-color:#d36133;color:#fff}.pagination__link_active{border:1px solid #d36133}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
